<template>
  <div class="education">
    <div class="education__list" v-if="items">
      <education-list
        v-if="items"
        @edit="editForm"
        @delete="getItems"
        :items="items"></education-list>
    </div>
    <div
      v-if="!visibleForm"
      class="education__actions fieldset-add">
      <a
        v-if="!visibleForm"
        @click="visibleForm = true"
        href="javascript:;" class="education__add-btn fieldset-add__add-btn">
        <i class="fa fa-plus"></i>&nbsp;добавить
      </a>
    </div>
    <div
      v-if="visibleForm"
      class="education__form education-form">
      <education-form
        v-if="visibleForm"
        @close="closeForm"
        @create="onCreate"
        @update="onUpdate"
        :ancet-id="this.ancetId"
        :object-item="objectInstance"></education-form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

import UtilsMixin from '../../vue_mixins/UtilsMixin.vue'

import EducationForm from './EducationForm.vue'
import EducationList from './EducationList.vue'


export default {

  name: 'Education',

  mixins: [UtilsMixin],

  props: {
    ancetId: {
      type: Number,
      default: null
    }
  },

  components: {
    EducationForm,
    EducationList
  },

  data () {
    return {
      items: null,
      errors: {},
      objectInstance: null,
      visibleForm: false
    }
  },

  mounted () {
    this.getItems()
  },

  methods: {
    getItems () {
      axios.get(`/ancet/api/educations/`, {params: {ancet_id: this.ancetId, uuid: this.uuid()}})
        .then(response => {
          this.items = response.data
        })
        .catch(error => {
          this.errors = error.response.data
        })
    },

    closeForm () {
      this.visibleForm = false
      this.errors = {}
      this.objectInstance = null
    },

    onCreate () {
      this.getItems()
      this.closeForm()
    },

    onUpdate () {
      this.getItems()
      this.closeForm()
    },

    editForm (objectInstance) {
      this.objectInstance = objectInstance
      this.visibleForm = true
    }
  }
}
</script>

<style lang="css" scoped>
</style>